<template>
  <div class="dynamic-fields">
    <div 
      v-for="(field, index) in fields" 
      :key="field.key"
      class="dynamic-fields__row"
      v-if="index % 2 === 0"
    >
      <dynamic-field
        :field="field"
        :value="fieldValues[field.key]"
        :error="errors[field.key]"
        @update="updateFieldValue(field.key, $event)"
      />
      
      <dynamic-field
        v-if="fields[index + 1]"
        :field="fields[index + 1]"
        :value="fieldValues[fields[index + 1].key]"
        :error="errors[fields[index + 1].key]"
        @update="updateFieldValue(fields[index + 1].key, $event)"
      />
    </div>
  </div>
</template>

<script>
import DynamicField from '../DynamicField/DynamicField.vue'

export default {
  name: 'DynamicFields',
  components: {
    DynamicField
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    values: {
      type: Object,
      default: () => ({})
    },
    errors: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fieldValues: {}
    }
  },
  watch: {
    values: {
      handler(newValues) {
        this.fieldValues = { ...newValues }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateFieldValue(fieldKey, value) {
      this.$set(this.fieldValues, fieldKey, value)
      this.$emit('update', { ...this.fieldValues })
    },
    resetFields() {
      this.fieldValues = {}
      this.$emit('update', {})
    }
  }
}
</script>

<style lang="scss" scoped>
.dynamic-fields {
  display: flex;
  flex-direction: column;
  gap: 25px;

  &__row {
    display: flex;
    gap: 20px;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 25px;
    }

    .dynamic-field {
      flex: 1;
    }
  }
}
</style>
